import moment from 'moment'
import { createSelector } from 'reselect'

import API from '../api/api'
import { CALENDAR_RANGE_PADDING_DAYS } from '../helpers/constants'

export const TRAININGS_TOGGLE_MY_ACTIVITES = 'TRAININGS_TOGGLE_MY_ACTIVITES'
export const TRAININGS_SET_EVENTS = 'TRAININGS_SET_EVENTS'
export const TRAININGS_UPDATE_EVENT = 'TRAININGS_UPDATE_EVENT'
export const TRAININGS_SET_START_END_DATE = 'TRAININGS_SET_START_END_DATE'
export const TRAININGS_TYPES_LOAD = 'TRAININGS_TYPES_LOAD'

export const initialState = {
  trainings: [],
  onlyMyActivities: false,
  startDate: moment().startOf('month').subtract(CALENDAR_RANGE_PADDING_DAYS, 'days').toDate(),
  endDate: moment().endOf('month').add(CALENDAR_RANGE_PADDING_DAYS, 'days').toDate(),
  trainingTypes: [],
}
const trainingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case TRAININGS_TOGGLE_MY_ACTIVITES:
      return {
        ...state,
        onlyMyActivities: !state.onlyMyActivities,
      }
    case TRAININGS_SET_EVENTS:
      return {
        ...state,
        trainings: [...action.trainings],
      }
    case TRAININGS_UPDATE_EVENT: {
      const updatedTrainings = [...state.trainings].filter(
        (training) => training.id !== action.event.id,
      )
      updatedTrainings.push(action.event)
      return {
        ...state,
        trainings: updatedTrainings,
      }
    }
    case TRAININGS_SET_START_END_DATE:
      return {
        ...state,
        startDate: action.startDate,
        endDate: action.endDate,
      }
    case TRAININGS_TYPES_LOAD: {
      return {
        ...state,
        trainingTypes: action.data,
      }
    }
    default:
      return state
  }
}

export const toggleActivities = () => {
  return {
    type: TRAININGS_TOGGLE_MY_ACTIVITES,
  }
}

export const setTrainings = (trainings) => {
  return {
    type: TRAININGS_SET_EVENTS,
    trainings,
  }
}

export const updateCalendarEvent = (event) => {
  return {
    type: TRAININGS_UPDATE_EVENT,
    event,
  }
}

export const setTrainingsDates = (start, end) => {
  return {
    type: TRAININGS_SET_START_END_DATE,
    startDate: start,
    endDate: end,
  }
}

export const fetchTrainingTypes = () => {
  return (dispatch) =>
    API.getTrainingTypes()
      .then((res) => {
        dispatch({ type: TRAININGS_TYPES_LOAD, data: res })
        return Promise.resolve(res)
      })
      .catch((err) => Promise.reject(err))
}

export const fetchAllTrainings = (start, end) => {
  return (dispatch) =>
    API.getBuildingSchedule(start, end)
      .then((res) => {
        dispatch(setTrainingsDates(start, end))
        dispatch(setTrainings(res))
        return Promise.resolve(res)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

export const fetchTrainingsByBuildingId = (start, end, buildingId) => {
  return (dispatch) =>
    API.getTrainingsByBuildingId(start, end, buildingId)
      .then((res) => {
        dispatch(setTrainingsDates(start, end))
        dispatch(setTrainings(res))
        return Promise.resolve(res)
      })
      .catch((err) => {
        return Promise.reject(err)
      })
}

export const selectTrainingTypes = (state) => state.trainings.trainingTypes
export const selectStartDate = (state) => state.trainings.startDate
export const selectEndDate = (state) => state.trainings.endDate
export const selectTrainingTypesForFilter = createSelector(selectTrainingTypes, (trainings) =>
  trainings.map((item) => ({
    id: item.id,
    avatar: item.icon,
    color: item.color,
    text: item.name,
    fee: 0,
    percentage: false,
  })),
)

export default trainingsReducer
